import { NgModule } from '@angular/core';
import { FocusDirective } from './directives/focus.directive';
import { SafeFullNamePipe } from './pipes/safe-full-name.pipe';
import { SafeUrlPipe } from './pipes/safe-url.pipe';
import { TeamAssigneePipe } from 'src/app/incident-assign/team-assignee.pipe';
import { NebulrTranslationService } from './services/nebulr-translation.service';
import { TooltipComponent } from './components/tooltip/tooltip.component';
import { ShowHidePasswordComponent } from './components/show-hide-password/show-hide-password.component';
import { IonicModule } from '@ionic/angular';
import { StripHtmlPipe } from './pipes/strip-html.pipe';
import { CommonModule } from '@angular/common';
import { PopoverComponent } from './components/popover/popover.component';
import { VerifyModalComponent } from './components/verify-modal/verify-modal.component';
import { TranslateModule } from '@ngx-translate/core';
import { FormattedPhoneNumberPipe } from './pipes/formatted-phone-number.pipe';
import { SafeTenantNamePipe } from './pipes/safe-tenant-name.pipe';

@NgModule({
  imports: [IonicModule, CommonModule, TranslateModule],
  declarations: [
    FocusDirective,
    SafeUrlPipe,
    TeamAssigneePipe,
    SafeFullNamePipe,
    SafeTenantNamePipe,
    TooltipComponent,
    ShowHidePasswordComponent,
    StripHtmlPipe,
    PopoverComponent,
    FormattedPhoneNumberPipe,
    VerifyModalComponent,
  ],
  providers: [
    SafeUrlPipe,
    SafeFullNamePipe,
    SafeTenantNamePipe,
    TeamAssigneePipe,
    StripHtmlPipe,
    FormattedPhoneNumberPipe,
    NebulrTranslationService,
  ],
  exports: [
    FocusDirective,
    SafeUrlPipe,
    TeamAssigneePipe,
    SafeFullNamePipe,
    SafeTenantNamePipe,
    FormattedPhoneNumberPipe,
    StripHtmlPipe,
    TooltipComponent,
    VerifyModalComponent,
    ShowHidePasswordComponent,
  ],
})
export class SharedModule {}
